import { NavigationItem, NavigationKey } from 'modules/experience-core';

export const INSIGHTS_NAVIGATION_ITEM: NavigationItem = {
  intlKey: 'navigation.insights',
  link: '/insights',
  key: NavigationKey.INSIGHTS,
  isVenueSpecific: false,
};

export const BEST_OF_WOLT_NAVIGATION_ITEM: NavigationItem = {
  intlKey: 'best-of-wolt.title',
  link: '/best-of-wolt',
  key: NavigationKey.BEST_OF_WOLT,
  isVenueSpecific: true,
};

export const ACCESS_MANAGEMENT_NAVIGATION_ITEM: NavigationItem = {
  intlKey: 'navigation.access-management',
  link: '/access',
  key: NavigationKey.ACCESS_MANAGEMENT,
  isVenueSpecific: false,
};

export const BUSINESS_DETAILS_NAVIGATION_ITEM: NavigationItem = {
  intlKey: 'navigation.business-details',
  link: '/details',
  key: NavigationKey.BUSINESS_DETAILS,
  isVenueSpecific: true,
};

export const PURCHASES_NAVIGATION_ITEM: NavigationItem = {
  intlKey: 'navigation.purchases',
  link: '/purchases',
  key: NavigationKey.PURCHASES,
  isVenueSpecific: true,
};

export const TRANSLATION_NAVIGATION_ITEM: NavigationItem = {
  intlKey: 'navigation.translation',
  link: '/translation',
  key: NavigationKey.TRANSLATION,
  isVenueSpecific: true,
};

export const CAMPAIGNS_NAVIGATION_ITEM: NavigationItem = {
  intlKey: 'campaigns.title',
  link: '/campaigns',
  key: NavigationKey.CAMPAIGNS,
  isVenueSpecific: false,
};

export const ALL_NAVIGATION_ITEMS = [
  INSIGHTS_NAVIGATION_ITEM,
  BEST_OF_WOLT_NAVIGATION_ITEM,
  ACCESS_MANAGEMENT_NAVIGATION_ITEM,
  BUSINESS_DETAILS_NAVIGATION_ITEM,
  PURCHASES_NAVIGATION_ITEM,
  TRANSLATION_NAVIGATION_ITEM,
  CAMPAIGNS_NAVIGATION_ITEM,
];
